// extracted by mini-css-extract-plugin
export var quillEditor = "_pn-1";
export var variable = "_pn-0";